import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { sipMiningApi } from "../../../app/slices/sipMining";
import SipTables from "./SipTables";
import NameDateSearchComponent from "../../../components/customTable/NameDateSearchComponent";

export default function SipMining() {
  const roleResponse = useSelector((state) => state.login.login.role);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const [activeTab, setActiveTab] = useState("ACTIVE");
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
    customerName: null,
  });

  // Fetch data for the active tab and query parameters
  useEffect(() => {
    const fetchData = async () => {
      const { customerName, startDate, endDate } = queryParams;
      try {
        await dispatch(
          sipMiningApi({
            status: activeTab,
            name: customerName,
            startDate,
            endDate,
          })
        ).unwrap();
      } catch (error) {
        console.error(`Failed to fetch data for ${activeTab}:`, error);
      }
    };

    fetchData();
  }, [dispatch, activeTab, queryParams]);

  // Selector for the API response
  const sliceResponse = useSelector((state) => state.sipMining.sipMining.data);
  const stateLoading = useSelector(
    (state) => state.sipMining.loading
  );

  useEffect(() => {
    if (sliceResponse) {
      const formattedData = sliceResponse?.map((originalData) => ({
        id: originalData._id || "N/A",
        clientId: originalData.client_id?._id || "N/A",
        clientName: originalData.client_id?.name || "N/A",
        partnerId: originalData.partner_id || "N/A",
        proposalNo: originalData.proposal_no || "N/A",
        orderType: originalData.order_type || "N/A",
        metalType: originalData.metal_type || "N/A",
        amount: originalData.amount || "N/A",
        quantity: originalData.quantity || "N/A",
        price: originalData.Price || "N/A",
        goldlivePrice: originalData.LivePrice[0].gBuy || "N/A",
        silverlivePrice: originalData.LivePrice[0].sBuy || "N/A",
        blockId: originalData.Blockid || "N/A",
        status: originalData.status || "N/A",
        proposalType: originalData.proposal_type || "N/A",
        dayOfMonth: originalData.day_of_month || "N/A",
        frequency: originalData.frequency || "N/A",
        isDeleted: originalData.is_deleted || "N/A",
        flag: originalData.flag || "N/A",
        createdAt: originalData.createdAt || "N/A",
        updatedAt: originalData.updatedAt || "N/A",
        sipStatus: originalData.sip_status || "N/A",
        subReferenceId: originalData.subReferenceId || "N/A",
        subscriptionId: originalData.subscriptionId || "N/A",
      }));
      setData(formattedData || []);
    }
  }, [sliceResponse]);

  // Handler for tab switching
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setQueryParams({
      startDate: null,
      endDate: null,
      customerName: null,
    });
  };

  // Handler for search functionality
  const handleSearchByDate = (startDate, endDate, customerName) => {
    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <>
      <Box>
        {/* <Box display="flex" justifyContent="center" mb={2} gap={1}> */}
        <Box
          display="flex"
          justifyContent={{ xs: "space-between", md: "center" }}
          alignItems="center"
          gap={{ xs: 0.5, md: 2 }}
          mb={2}
          sx={{
            width: "100%",
            flexWrap: "nowrap", // ✅ Always one row
          }}
        >
          {[
            "ACTIVE",
            "Initialized",
            "CANCELLED",
            "LINK_EXPIRED",
            "BANK_APPROVAL_PENDING",
          ].map((tab) => (
            <Button
              key={tab}
              variant={activeTab === tab ? "contained" : "outlined"}
              onClick={() => handleTabChange(tab)}
              sx={{
                flex: 1, // ✅ Equal width for all buttons
                height: { xs: 40, sm: 60, md: 35 }, // ✅ Equal height
                maxWidth: { xs: "100%", md: 210 }, // ✅ Better alignment on desktop
                fontSize: { xs: "10px", sm: "13px", md: "14px" },
                padding: { xs: "5px 4px", md: "8px 8px" },

                display: "flex",
                flexDirection: {
                  xs: "column", // ✅ Mobile: stacked
                  md: "row", // ✅ Desktop: normal text
                },
                justifyContent: "center",
                alignItems: "center",
                whiteSpace: "normal",
                // textAlign: "center",
                lineHeight: 1.2,
              }}
            >
              {tab.includes("_") && window.innerWidth < 600 ? (
                <>
                  {tab.split("_")[0]}
                  <br />
                  {tab.split("_")[1]}
                  <br />
                  {tab.split("_")[2]}
                </>
              ) : (
                tab
                // tab.replace("_", " ")
              )}
              {/* {tab.replace("_", " ")} */}
            </Button>
          ))}
        </Box>
        {[
          "ACTIVE",
          "Initialized",
          "CANCELLED",
          "LINK_EXPIRED",
          "BANK_APPROVAL_PENDING",
        ].map(
          (tab) =>
            activeTab === tab &&
            roleResponse?.SIPMining?.read === 1 && (
              <Box key={tab} >
                <NameDateSearchComponent onSearch={handleSearchByDate} />
                <Box mt={2}>

                  <SipTables sliceResponse={data || []}
                    stateLoading={stateLoading}
                  />
                </Box>
              </Box>
            )
        )}
      </Box>
    </>
  );
}
